export default "__VITE_ASSET__oMIA9rLK__"